import React from "react";
import { useNavigate } from "react-router-dom";
import { Text, ActionButton } from "@jds/core";
import { IcJioDot } from "@jds/core-icons";
import "../styles/contactUs.css";
import config from "../utils/config";

const SignUp = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    if (!config.signupLoginUrl) {
      console.warn("REACT_APP_SIGNUP_LOGIN_URL is not configured");
      return;
    }
    window.location.href = config.signupLoginUrl;
  };

  return (
    <div className="contact-page">
      <div className="contact-card">
        <div className="logoDiv">
          <div className="logoStyle">
            <IcJioDot width={40} height={40} />
          </div>
          <Text appearance="heading-xxs">Consent Management</Text>
        </div>

        <div className="contact-content">
          <div className="container-header">
            <Text appearance="heading-xs">Sign up</Text>
          </div>

          <div className="contact-box">
            <Text appearance="body-s" color="primary-grey-80">
              Organisation onboarding is handled through your administrator. If you already have access,
              sign in below.
            </Text>
          </div>

          <br />
          <ActionButton
            label="Log in"
            onClick={handleLogin}
            stretch
          />
          <div style={{ marginTop: 12 }}>
            <ActionButton label="Back to home" onClick={() => navigate("/")} stretch />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
